// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialValue = {
  courseDetails: null,
  syllabusDrawerOpen: false,
  pageDetails: null,
  pageFooterDetails: null
}

export const learnerSlice = createSlice({
  name: 'learner',
  initialState: {
    ...initialValue
  },
  reducers: {
    updateCourseDetailsUnlockStatus(state, action) {
      const { topicId, pageId } = action.payload

      state.courseDetails.topics = state.courseDetails.topics.map((topic) => {
        if (topic?.id === topicId) {
          return {
            ...topic,
            pages: topic.pages.map((page) => {
              if (page?.id === pageId) {
                return { ...page, isLock: false }
              }
              return page
            })
          }
        }
        return topic
      })
    },
    updateCourseDetailsCompleteStatus(state, action) {
      const { topicId, pageId } = action.payload
      state.courseDetails.topics = state.courseDetails.topics.map((topic) => {
        if (topic?.id === topicId) {
          return {
            ...topic,
            pages: topic.pages.map((page) => {
              if (page?.id === pageId) {
                return { ...page, isCompleted: true }
              }
              return page
            })
          }
        }
        return topic
      })
    },
    setLearnerCoursePageFooterDetails(state, action) {
      state.pageFooterDetails = action.payload
    },
    setLearnerCoursePageDetails(state, action) {
      state.pageDetails = action.payload
    },
    setLearnerCourseDetails(state, action) {
      state.courseDetails = action.payload
    },
    setSyallbusDrawerOpen(state, action) {
      state.syllabusDrawerOpen = action.payload
    },
    resetLearnerSlice(state) {
      Object.keys(initialValue).forEach((key) => {
        state[key] = initialValue[key]
      })
    }
  }
})

export const {
  resetLearnerSlice,
  setSyallbusDrawerOpen,
  setLearnerCourseDetails,
  setLearnerCoursePageDetails,
  setLearnerCoursePageFooterDetails,
  updateCourseDetailsUnlockStatus,
  updateCourseDetailsCompleteStatus
} = learnerSlice.actions

export default learnerSlice.reducer
